import React, { useState } from "react";
import { SUBSCRIBE_INTERVALS, PRODUCTS } from "@/data/catalog";
import { useCart } from "@/context/CartContext";

export const SubscribeSave = () => {
  const { addItem } = useCart();
  const [interval, setInterval] = useState("4w");

  return (
    <section id="subscribe-save" className="bg-[#F8F5EF] py-16 md:py-24" data-testid="subscribe-save">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="rounded-3xl overflow-hidden shadow-[0_8px_40px_rgba(111,80,58,0.08)]">
          <img
            src="/assets/subscribe.png"
            alt="Baby Hemp Subscribe & Save — gentle care delivered when you need it most. Save 15% every time. Pause, skip or cancel anytime. Choose your delivery frequency."
            loading="lazy"
            className="w-full h-auto block"
          />
        </div>

        {/* Functional action bar */}
        <div className="mt-8 bg-white rounded-3xl p-6 md:p-8 shadow-[0_4px_24px_rgba(111,80,58,0.05)]">
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-[#B8C4A3] text-center mb-4">
            Subscribe to your patch packs
          </p>
          <div className="flex flex-wrap justify-center gap-2.5">
            {SUBSCRIBE_INTERVALS.map((opt) => (
              <button
                key={opt.id}
                data-testid={`interval-${opt.id}`}
                onClick={() => setInterval(opt.id)}
                className={`px-4 py-2.5 rounded-full text-sm font-medium border-2 transition-colors ${
                  interval === opt.id
                    ? "border-[#6F503A] bg-[#6F503A] text-[#F8F5EF]"
                    : "border-[#6F503A]/15 text-[#6F503A] hover:border-[#6F503A]/40"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <button
            data-testid="subscribe-cta"
            onClick={() => addItem(PRODUCTS.patch, { qty: 1, sellingPlan: "subscribe", interval })}
            className="mt-5 w-full md:w-auto md:mx-auto md:flex px-8 py-4 rounded-full bg-[#6F503A] text-[#F8F5EF] font-medium hover:bg-[#5b4130] transition-colors items-center justify-center"
          >
            Subscribe &amp; Save 15%
          </button>
        </div>
      </div>
    </section>
  );
};
